export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register.result': 'Register Result',
  'menu.dashboard': 'Trang chủ',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.register-result': 'Kết quả đăng ký',
  'menu.Calendar': 'Lịch',
  'menu.News': 'Tin tức',
  'menu.Structure': 'Tổ chức',
  'menu.LopTinChi': 'Lớp tín chỉ',
  'menu.Dashboard': 'Trang chủ',
  'menu.LopHanhChinh': 'Lớp hành chính',
  'menu.QuanLyLop': 'Quản lý lớp',
  'menu.QuanLyTrongMuon': 'Quản lý trông muộn',
  'menu.QuanLyLichHoc': 'Quản lý đào tạo',
  'menu.QuanLyLichHoc.LichHoc': 'Lịch học',
  'menu.QuanLyLichHoc.LichHoc.Template': 'Template Lịch học',
  'menu.QuanLyLichHoc.ThongTinDaoTao': 'Giáo án',
  'menu.QuanLyLichHoc.ThongTinDaoTao.PhuongPhapGiaoDuc': 'Phương pháp giáo dục',
  'menu.QuanLyLichHoc.ThongTinDaoTao.LinhVucPhatTrien': 'Lĩnh vực phát triển',
  'menu.QuanLyLichHoc.ThongTinDaoTao.QuanLyBaiHoc': 'Bài học',
  'menu.KhaiBaoThongTin': 'Khai báo thông tin',
  'menu.ChucNangPhuHuynh': 'Chức năng phụ huynh',
  'menu.ChucNangGiaoVien': 'Chức năng giáo viên',
  'menu.KhaiBaoThongTin.ThongTinCaNhan': 'Thông tin cá nhân',
  'menu.KhaiBaoThongTin.ThongTinCon': 'Thông tin con',
  'menu.NangCapTaiKhoan': 'Nâng cấp tài khoản',
  'menu.QuanLyTaiKhoan': 'Quản lý tài khoản',
  'menu.QuanLyTaiKhoan.TaiKhoanHieuTruong': 'Tài khoản hiệu trưởng',
  'menu.QuanLyTaiKhoan.TaiKhoanChuTruong': 'Tài khoản chủ trường',
  'menu.QuanLyTaiKhoan.TaiKhoanGiaoVien': 'Tài khoản giáo viên',
  'menu.QuanLyTaiKhoan.TaiKhoanPhuHuynh': 'Tài khoản phụ huynh',
  'menu.QuanLyTaiKhoan.TaiKhoanKhach': 'Tài khoản khách',
  'menu.QuanLyDiemDanhPhuHuynh': 'Quản lý điểm danh',
  'menu.QuanLyDiemDanhPhuHuynh.DiemDanhDauGioPhuHuynh': 'Điểm danh đầu giờ',
  'menu.QuanLyDiemDanhPhuHuynh.DiemDanhDonCon': 'Điểm danh đón con',
  'menu.ThongBao': 'Thông báo quan trọng',
  'menu.AlbumAnh': 'Album ảnh',
  'menu.DungLuongAlbumAnh': 'Dung lượng album ảnh',
  'menu.QuanLyCauHinh': 'Quản lý cấu hình',
  'menu.QuanLyThucPham': 'Quản lý thực phẩm',
  'menu.QuanLyThucPham.QuyDoi': 'Bảng quy đổi',
  'menu.QuanLyThucPham.DanhMucThucPham': 'Danh mục thực phẩm',
  'menu.QuanLyThucPham.QuanLyNhaCungCap': 'Quản lý nhà cung cấp',
  'menu.QuanLyThucPham.DanhMucMonAn': 'Danh mục món ăn',
  'menu.QuanLyThucPham.QuyDinhChung': 'Quy định chung',
  'menu.QuanLyThucPham.QuyDinhChung.BangDinhDuong': 'Quy định dinh dưỡng',
  'menu.QuanLyThucPham.QuyDinhChung.QuyDinhThucDon': 'Quy định thực đơn',
  'menu.QuanLyThucPham.QuyDinhChung.QuyDinhChung': 'Quy định chung',
  'menu.QuanLyThucPham.KhauPhanAn': 'Lên thực đơn',
  'menu.QuanLyThucPham.LenThucDonMau': 'Lên thực đơn mẫu',
  'menu.QuanLyThucPham.CloneMenu': 'Clone menu',
  'menu.QuanLyThucPham.ThucPhamKho': 'Kho thực phẩm',
  'menu.QuanLyThucPham.HoaDon': 'Hóa đơn mua hàng',
  'menu.QuanLyThucPham.TienThua': 'Quản lý tiền thừa',
  'menu.QuanLyThucPham.KiemThu': 'Kiểm thử ba bước',
  'menu.QuanLyThucPham.BaoCao': 'Báo cáo',
  'menu.QuanLyThucPham.BaoCao.So3BuocTongHop': 'Số 3 bước tổng hợp',
  'menu.QuanLyThucPham.BaoCao.So3BuocTongHop.Buoc1_1': 'Bước 1-1',
  'menu.QuanLyThucPham.BaoCao.So3BuocTongHop.Buoc1_2': 'Bước 1-2',
  'menu.QuanLyThucPham.BaoCao.So3BuocTongHop.Buoc2': 'Bước 2',
  'menu.QuanLyThucPham.BaoCao.So3BuocTongHop.Buoc3': 'Bước 3',
  'menu.ThucDonVaLichHocAnh': 'Thực đơn/ Lịch học dạng ảnh',
  'menu.ThucDonVaLichHocAnh.ThucDonAnh': 'Thực đơn',
  'menu.ThucDonVaLichHocAnh.LichHocAnh': 'Lịch học',
  'menu.DotDanhGiaSucKhoe': 'Đợt đánh giá sức khỏe',
  'menu.DoanhThu': 'Báo cáo doanh thu',
  'menu.CloneMenu': 'Lên menu trường',
  'menu.NoiBo': 'Báo cáo nội bộ',
  'menu.QuanLyTaiSan': 'Quản lý tài sản',
  'menu.QuanLyTaiSan.DanhMucTaiSan': 'Danh mục tài sản',
  'menu.QuanLyTaiSan.BaoHongSuaChua': 'Báo hỏng, sửa chữa',
  'menu.QuanLyBaoCao': 'Quản lý báo cáo',
  'menu.QuanLyBaoCao.BaoCaoSBN': 'Báo cáo sở ban ngành',
  'menu.QuanLyBaoCao.BaoCaoHeThong': 'Báo cáo hệ thống',
  'menu.QuanLyBaoCao.BaoCaoNoiBo': 'Báo cáo nội bộ',
  'menu.QuanLyTuongTac': 'Quản lý tương tác',
  'menu.QuanLyTuongTac.QuanLyTinTuc': 'Tin tức',
  'menu.QuanLyTuongTac.QuanLyKhaoSat': 'Khảo sát',
  'menu.QuanLyTuongTac.HoatDongNgoaiKhoa': 'Hoạt động ngoại khóa',
  'menu.QuangCao': 'Đăng tin quảng cáo',
  'menu.QuanLyTuongTac.QuanLyDon': 'Quản lý đơn',
  'menu.QuanLyTuongTac.QuanLyDon.DonXinNghiHoc': 'Đơn xin nghỉ học',
  'menu.QuanLyTuongTac.QuanLyDon.DonDanDonVe': 'Đơn dặn đón về',
  'menu.QuanLyTuongTac.QuanLyDon.DonDanThuoc': 'Đơn dặn thuốc',
  'menu.QuanLyTuongTac.QuanLyDon.LoiDanCuaPhuHuynh': 'Lời nhắn của phụ huynh',
  'menu.Truong': 'Trường',
  'menu.Truong.ThongTinTruong': 'Thông tin trường',
  'menu.QuanLyTruong': 'Quản lý trường',
  'menu.QuanLyGiaoVien': 'Quản lý giáo viên',
  'menu.QuanLyGiaoVien.DiemDanhGiaoVien': 'Chấm công',
  'menu.QuanLyGiaoVien.ThongKeLuong': 'Tính lương',
  'menu.QuanLyGiaoVien.QuanLyThuBay': 'Quản lý thứ 7',
  'menu.QuanLyGiaoVien.DanhGiaGiaoVien': 'Đánh giá',
  'menu.QuanLyHocSinh': 'Quản lý học sinh',
  'menu.QuanLyHocSinh.ThongTinHocSinh': 'Thông tin học sinh',
  'menu.QuanLyHocSinh.ThongTinHocPhi': 'Thông tin học phí',
  'menu.QuanLyHocSinh.QuanLyHocThuBay': 'Quản lý học thứ 7',
  'menu.QuanLyHocSinh.QuanLyDiemDanh': 'Quản lý điểm danh',
  'menu.QuanLyHocSinh.QuanLyDiemDanh.DiemDanh': 'Điểm danh',
  'menu.QuanLyHocSinh.QuanLyDiemDanh.DiemDanhMuon': 'Điểm danh muộn',
  'menu.QuanLyHocSinh.QuanLyDiemDanh.DiemDanhThuBay': 'Điểm danh thứ 7',
  'menu.QuanLyHocSinh.DanhGiaDinhKyHocSinh': 'Đánh giá',
  'menu.QuanLyHocSinh.MauDanhGia': 'Mẫu đánh giá',
  'menu.QuanTriPhanQuyen': 'Quản trị phân quyền',
  'menu.BaoCaoQuanTri': 'Báo cáo quản trị',
  'menu.QuanTriPhanQuyen.VaiTroQuanLy': 'Vai trò quản lý',
  'menu.QuanTriPhanQuyen.ChucNangQuanTri': 'Chức năng quản lý',
  'menu.QuanLyCamera': 'Quản lý camera',
};
